export default __webpack_public_path__ + "static/media/t2e.3248f553.png";